const defaultAttendanceTimeFormatter = (date) => {
  if(!date) return ''

  const newDate = new Date(date)
  return `${newDate.getMinutes()}m ${newDate.getSeconds()}s`
}

export { defaultAttendanceTimeFormatter }